@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(-779_243_288)
internal val Res.string.shop_purchase_success: StringResource by lazy {
      StringResource("string:shop_purchase_success", "shop_purchase_success", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 1396, 93),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 964, 69),
      ))
    }

@delegate:ResourceContentHash(842_299_673)
internal val Res.string.shop_purchased: StringResource by lazy {
      StringResource("string:shop_purchased", "shop_purchased", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 1490, 42),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 1034, 34),
      ))
    }

@delegate:ResourceContentHash(-339_021_536)
internal val Res.string.shop_spendable_balance: StringResource by lazy {
      StringResource("string:shop_spendable_balance", "shop_spendable_balance", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 1533, 42),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 1069, 42),
      ))
    }

@delegate:ResourceContentHash(-657_619_209)
internal val Res.string.shop_title: StringResource by lazy {
      StringResource("string:shop_title", "shop_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_shop.commonMain.cvr", 1576, 54),
        ResourceItem(setOf(), "${MD}values/strings_shop.commonMain.cvr", 1112, 38),
      ))
    }

@delegate:ResourceContentHash(1_653_918_927)
internal val Res.string.streak_squad_day_one: StringResource by lazy {
      StringResource("string:streak_squad_day_one", "streak_squad_day_one", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 10, 48),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 10, 44),
      ))
    }

@delegate:ResourceContentHash(1_213_034_846)
internal val Res.string.streak_squad_days: StringResource by lazy {
      StringResource("string:streak_squad_days", "streak_squad_days", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 59, 41),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 55, 37),
      ))
    }

@delegate:ResourceContentHash(-2_073_350_626)
internal val Res.string.streak_squad_freezes_left: StringResource by lazy {
      StringResource("string:streak_squad_freezes_left", "streak_squad_freezes_left", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 101, 65),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 93, 57),
      ))
    }

@delegate:ResourceContentHash(1_564_433_323)
internal val Res.string.streak_squad_maintained_today: StringResource by lazy {
      StringResource("string:streak_squad_maintained_today", "streak_squad_maintained_today", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 167, 105),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 151, 69),
      ))
    }

@delegate:ResourceContentHash(-673_676_769)
internal val Res.string.streak_squad_nudge_btn: StringResource by lazy {
      StringResource("string:streak_squad_nudge_btn", "streak_squad_nudge_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 273, 50),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 221, 46),
      ))
    }

@delegate:ResourceContentHash(1_869_321_590)
internal val Res.string.streak_squad_nudged_toast: StringResource by lazy {
      StringResource("string:streak_squad_nudged_toast", "streak_squad_nudged_toast", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 324, 117),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 268, 61),
      ))
    }

@delegate:ResourceContentHash(185_875_834)
internal val Res.string.streak_squad_start_action: StringResource by lazy {
      StringResource("string:streak_squad_start_action", "streak_squad_start_action", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 442, 49),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 330, 41),
      ))
    }

@delegate:ResourceContentHash(1_404_790_441)
internal val Res.string.streak_squad_start_prompt: StringResource by lazy {
      StringResource("string:streak_squad_start_prompt", "streak_squad_start_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 492, 121),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 372, 81),
      ))
    }

@delegate:ResourceContentHash(-1_560_320_639)
internal val Res.string.streak_squad_title: StringResource by lazy {
      StringResource("string:streak_squad_title", "streak_squad_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 614, 66),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 454, 42),
      ))
    }

@delegate:ResourceContentHash(1_653_931_300)
internal val Res.string.streak_squad_waiting_peer: StringResource by lazy {
      StringResource("string:streak_squad_waiting_peer", "streak_squad_waiting_peer", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 681, 81),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 497, 73),
      ))
    }

@delegate:ResourceContentHash(-1_261_494_803)
internal val Res.string.streak_squad_waiting_you: StringResource by lazy {
      StringResource("string:streak_squad_waiting_you", "streak_squad_waiting_you", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_streaks.commonMain.cvr", 763, 148),
        ResourceItem(setOf(), "${MD}values/strings_streaks.commonMain.cvr", 571, 96),
      ))
    }

@delegate:ResourceContentHash(-2_004_708_409)
internal val Res.string.tasks_action_enable_steps: StringResource by lazy {
      StringResource("string:tasks_action_enable_steps", "tasks_action_enable_steps", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 10, 69),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 10, 49),
      ))
    }

@delegate:ResourceContentHash(-1_514_293_337)
internal val Res.string.tasks_action_open: StringResource by lazy {
      StringResource("string:tasks_action_open", "tasks_action_open", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 80, 45),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 60, 33),
      ))
    }

@delegate:ResourceContentHash(-652_438_198)
internal val Res.string.tasks_action_replace: StringResource by lazy {
      StringResource("string:tasks_action_replace", "tasks_action_replace", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 126, 52),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 94, 40),
      ))
    }

@delegate:ResourceContentHash(416_237_457)
internal val Res.string.tasks_all_done: StringResource by lazy {
      StringResource("string:tasks_all_done", "tasks_all_done", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 383, 82),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 263, 46),
      ))
    }

@delegate:ResourceContentHash(2_128_719_824)
internal val Res.string.tasks_all_done_body: StringResource by lazy {
      StringResource("string:tasks_all_done_body", "tasks_all_done_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 179, 203),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 135, 127),
      ))
    }

@delegate:ResourceContentHash(2_115_846_773)
internal val Res.string.tasks_completed: StringResource by lazy {
      StringResource("string:tasks_completed", "tasks_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 466, 47),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 310, 35),
      ))
    }

@delegate:ResourceContentHash(33_348_146)
internal val Res.string.tasks_error_load: StringResource by lazy {
      StringResource("string:tasks_error_load", "tasks_error_load", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 514, 120),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 346, 68),
      ))
    }

@delegate:ResourceContentHash(953_131_872)
internal val Res.string.tasks_error_replace: StringResource by lazy {
      StringResource("string:tasks_error_replace", "tasks_error_replace", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 635, 107),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 415, 67),
      ))
    }

@delegate:ResourceContentHash(-1_641_408_490)
internal val Res.string.tasks_error_steps_permission: StringResource by lazy {
      StringResource("string:tasks_error_steps_permission", "tasks_error_steps_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 743, 196),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 483, 124),
      ))
    }

@delegate:ResourceContentHash(-160_182_594)
internal val Res.string.tasks_error_steps_replacement: StringResource by lazy {
      StringResource("string:tasks_error_steps_replacement", "tasks_error_steps_replacement", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 940, 217),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 608, 113),
      ))
    }

@delegate:ResourceContentHash(1_711_733_521)
internal val Res.string.tasks_error_steps_unavailable: StringResource by lazy {
      StringResource("string:tasks_error_steps_unavailable", "tasks_error_steps_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 1158, 229),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 722, 141),
      ))
    }

@delegate:ResourceContentHash(1_073_911_632)
internal val Res.string.tasks_level: StringResource by lazy {
      StringResource("string:tasks_level", "tasks_level", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 1388, 47),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 864, 35),
      ))
    }

@delegate:ResourceContentHash(2_069_040_672)
internal val Res.string.tasks_like_body: StringResource by lazy {
      StringResource("string:tasks_like_body", "tasks_like_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 1436, 175),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 900, 79),
      ))
    }

@delegate:ResourceContentHash(1_930_609_186)
internal val Res.string.tasks_like_title: StringResource by lazy {
      StringResource("string:tasks_like_title", "tasks_like_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 1612, 84),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 980, 56),
      ))
    }

@delegate:ResourceContentHash(1_202_041_009)
internal val Res.string.tasks_loading: StringResource by lazy {
      StringResource("string:tasks_loading", "tasks_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 1697, 89),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1037, 53),
      ))
    }

@delegate:ResourceContentHash(-1_818_255_585)
internal val Res.string.tasks_message_body: StringResource by lazy {
      StringResource("string:tasks_message_body", "tasks_message_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 1787, 126),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1091, 74),
      ))
    }

@delegate:ResourceContentHash(506_319_598)
internal val Res.string.tasks_message_title: StringResource by lazy {
      StringResource("string:tasks_message_title", "tasks_message_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 1914, 79),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1166, 59),
      ))
    }

@delegate:ResourceContentHash(-114_845_887)
internal val Res.string.tasks_post_body: StringResource by lazy {
      StringResource("string:tasks_post_body", "tasks_post_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 1994, 119),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1226, 59),
      ))
    }

@delegate:ResourceContentHash(-1_621_783_491)
internal val Res.string.tasks_post_title: StringResource by lazy {
      StringResource("string:tasks_post_title", "tasks_post_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2114, 84),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1286, 60),
      ))
    }

@delegate:ResourceContentHash(1_059_842_977)
internal val Res.string.tasks_progress_summary: StringResource by lazy {
      StringResource("string:tasks_progress_summary", "tasks_progress_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2199, 74),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1347, 62),
      ))
    }

@delegate:ResourceContentHash(1_729_179_413)
internal val Res.string.tasks_replacement_used: StringResource by lazy {
      StringResource("string:tasks_replacement_used", "tasks_replacement_used", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2274, 106),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1410, 62),
      ))
    }

@delegate:ResourceContentHash(2_069_748_683)
internal val Res.string.tasks_reply_body: StringResource by lazy {
      StringResource("string:tasks_reply_body", "tasks_reply_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2381, 128),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1473, 76),
      ))
    }

@delegate:ResourceContentHash(-2_039_201_356)
internal val Res.string.tasks_reply_title: StringResource by lazy {
      StringResource("string:tasks_reply_title", "tasks_reply_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2510, 93),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1550, 53),
      ))
    }

@delegate:ResourceContentHash(1_796_747_229)
internal val Res.string.tasks_retry: StringResource by lazy {
      StringResource("string:tasks_retry", "tasks_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2604, 43),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1604, 31),
      ))
    }

@delegate:ResourceContentHash(758_063_673)
internal val Res.string.tasks_save_body: StringResource by lazy {
      StringResource("string:tasks_save_body", "tasks_save_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2648, 119),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1636, 63),
      ))
    }

@delegate:ResourceContentHash(-1_639_437_807)
internal val Res.string.tasks_save_title: StringResource by lazy {
      StringResource("string:tasks_save_title", "tasks_save_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2768, 72),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1700, 56),
      ))
    }

@delegate:ResourceContentHash(-1_360_204_429)
internal val Res.string.tasks_steps_body: StringResource by lazy {
      StringResource("string:tasks_steps_body", "tasks_steps_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 2841, 196),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1757, 120),
      ))
    }

@delegate:ResourceContentHash(1_828_783_453)
internal val Res.string.tasks_steps_consent_body: StringResource by lazy {
      StringResource("string:tasks_steps_consent_body", "tasks_steps_consent_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 3038, 684),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 1878, 332),
      ))
    }

@delegate:ResourceContentHash(867_543_102)
internal val Res.string.tasks_steps_consent_continue: StringResource by lazy {
      StringResource("string:tasks_steps_consent_continue", "tasks_steps_consent_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 3723, 64),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2211, 48),
      ))
    }

@delegate:ResourceContentHash(-1_193_481_716)
internal val Res.string.tasks_steps_consent_not_now: StringResource by lazy {
      StringResource("string:tasks_steps_consent_not_now", "tasks_steps_consent_not_now", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 3788, 59),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2260, 47),
      ))
    }

@delegate:ResourceContentHash(951_601_139)
internal val Res.string.tasks_steps_consent_title: StringResource by lazy {
      StringResource("string:tasks_steps_consent_title", "tasks_steps_consent_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 3848, 93),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2308, 69),
      ))
    }

@delegate:ResourceContentHash(416_570_702)
internal val Res.string.tasks_steps_opt_in_body: StringResource by lazy {
      StringResource("string:tasks_steps_opt_in_body", "tasks_steps_opt_in_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 3942, 351),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2378, 163),
      ))
    }

@delegate:ResourceContentHash(286_501_034)
internal val Res.string.tasks_steps_opt_in_title: StringResource by lazy {
      StringResource("string:tasks_steps_opt_in_title", "tasks_steps_opt_in_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 4294, 100),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2542, 64),
      ))
    }

@delegate:ResourceContentHash(1_332_621_971)
internal val Res.string.tasks_steps_title: StringResource by lazy {
      StringResource("string:tasks_steps_title", "tasks_steps_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 4395, 65),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2607, 49),
      ))
    }

@delegate:ResourceContentHash(1_852_804_434)
internal val Res.string.tasks_streak: StringResource by lazy {
      StringResource("string:tasks_streak", "tasks_streak", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 4461, 52),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2657, 40),
      ))
    }

@delegate:ResourceContentHash(1_387_381_412)
internal val Res.string.tasks_title: StringResource by lazy {
      StringResource("string:tasks_title", "tasks_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 4514, 39),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2698, 27),
      ))
    }

@delegate:ResourceContentHash(1_773_032_597)
internal val Res.string.tasks_today: StringResource by lazy {
      StringResource("string:tasks_today", "tasks_today", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 4554, 39),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2726, 27),
      ))
    }

@delegate:ResourceContentHash(1_470_001_925)
internal val Res.string.tasks_unknown_body: StringResource by lazy {
      StringResource("string:tasks_unknown_body", "tasks_unknown_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 4594, 102),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2754, 70),
      ))
    }

@delegate:ResourceContentHash(-509_707_353)
internal val Res.string.tasks_unknown_title: StringResource by lazy {
      StringResource("string:tasks_unknown_title", "tasks_unknown_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 4697, 79),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2825, 43),
      ))
    }

@delegate:ResourceContentHash(-339_021_536)
internal val Res.string.tasks_xp: StringResource by lazy {
      StringResource("string:tasks_xp", "tasks_xp", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_tasks.commonMain.cvr", 4777, 28),
        ResourceItem(setOf(), "${MD}values/strings_tasks.commonMain.cvr", 2869, 28),
      ))
    }

@delegate:ResourceContentHash(-831_728_512)
internal val Res.string.value_passthrough: StringResource by lazy {
      StringResource("string:value_passthrough", "value_passthrough", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 9439, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6585, 33),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString8Resources(map: MutableMap<String, StringResource>) {
  map.put("shop_purchase_success", Res.string.shop_purchase_success)
  map.put("shop_purchased", Res.string.shop_purchased)
  map.put("shop_spendable_balance", Res.string.shop_spendable_balance)
  map.put("shop_title", Res.string.shop_title)
  map.put("streak_squad_day_one", Res.string.streak_squad_day_one)
  map.put("streak_squad_days", Res.string.streak_squad_days)
  map.put("streak_squad_freezes_left", Res.string.streak_squad_freezes_left)
  map.put("streak_squad_maintained_today", Res.string.streak_squad_maintained_today)
  map.put("streak_squad_nudge_btn", Res.string.streak_squad_nudge_btn)
  map.put("streak_squad_nudged_toast", Res.string.streak_squad_nudged_toast)
  map.put("streak_squad_start_action", Res.string.streak_squad_start_action)
  map.put("streak_squad_start_prompt", Res.string.streak_squad_start_prompt)
  map.put("streak_squad_title", Res.string.streak_squad_title)
  map.put("streak_squad_waiting_peer", Res.string.streak_squad_waiting_peer)
  map.put("streak_squad_waiting_you", Res.string.streak_squad_waiting_you)
  map.put("tasks_action_enable_steps", Res.string.tasks_action_enable_steps)
  map.put("tasks_action_open", Res.string.tasks_action_open)
  map.put("tasks_action_replace", Res.string.tasks_action_replace)
  map.put("tasks_all_done", Res.string.tasks_all_done)
  map.put("tasks_all_done_body", Res.string.tasks_all_done_body)
  map.put("tasks_completed", Res.string.tasks_completed)
  map.put("tasks_error_load", Res.string.tasks_error_load)
  map.put("tasks_error_replace", Res.string.tasks_error_replace)
  map.put("tasks_error_steps_permission", Res.string.tasks_error_steps_permission)
  map.put("tasks_error_steps_replacement", Res.string.tasks_error_steps_replacement)
  map.put("tasks_error_steps_unavailable", Res.string.tasks_error_steps_unavailable)
  map.put("tasks_level", Res.string.tasks_level)
  map.put("tasks_like_body", Res.string.tasks_like_body)
  map.put("tasks_like_title", Res.string.tasks_like_title)
  map.put("tasks_loading", Res.string.tasks_loading)
  map.put("tasks_message_body", Res.string.tasks_message_body)
  map.put("tasks_message_title", Res.string.tasks_message_title)
  map.put("tasks_post_body", Res.string.tasks_post_body)
  map.put("tasks_post_title", Res.string.tasks_post_title)
  map.put("tasks_progress_summary", Res.string.tasks_progress_summary)
  map.put("tasks_replacement_used", Res.string.tasks_replacement_used)
  map.put("tasks_reply_body", Res.string.tasks_reply_body)
  map.put("tasks_reply_title", Res.string.tasks_reply_title)
  map.put("tasks_retry", Res.string.tasks_retry)
  map.put("tasks_save_body", Res.string.tasks_save_body)
  map.put("tasks_save_title", Res.string.tasks_save_title)
  map.put("tasks_steps_body", Res.string.tasks_steps_body)
  map.put("tasks_steps_consent_body", Res.string.tasks_steps_consent_body)
  map.put("tasks_steps_consent_continue", Res.string.tasks_steps_consent_continue)
  map.put("tasks_steps_consent_not_now", Res.string.tasks_steps_consent_not_now)
  map.put("tasks_steps_consent_title", Res.string.tasks_steps_consent_title)
  map.put("tasks_steps_opt_in_body", Res.string.tasks_steps_opt_in_body)
  map.put("tasks_steps_opt_in_title", Res.string.tasks_steps_opt_in_title)
  map.put("tasks_steps_title", Res.string.tasks_steps_title)
  map.put("tasks_streak", Res.string.tasks_streak)
  map.put("tasks_title", Res.string.tasks_title)
  map.put("tasks_today", Res.string.tasks_today)
  map.put("tasks_unknown_body", Res.string.tasks_unknown_body)
  map.put("tasks_unknown_title", Res.string.tasks_unknown_title)
  map.put("tasks_xp", Res.string.tasks_xp)
  map.put("value_passthrough", Res.string.value_passthrough)
}
